/* custom_home_v2.js — GioielliTosti.it Home Page v2 (ottimizzato) */
(function () {
  'use strict';

  function fixBg() {
    document.querySelectorAll('.gh3').forEach(function (w) {
      var n = w.parentNode;
      while (n && n.nodeName !== 'BODY') {
        if (n.classList && n.classList.contains('shopify-section')) {
          n.style.setProperty('background','#ffffff','important');
          n.style.setProperty('padding-top','0','important');
          n.style.setProperty('padding-bottom','0','important');
          n.style.setProperty('margin-top','0','important');
          n.style.setProperty('margin-bottom','0','important');
          break;
        }
        n = n.parentNode;
      }
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.g3r');
    if (!els.length) return;
    var vh = window.innerHeight;
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('on'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -28px 0px' });
      els.forEach(function (el) {
        if (el.getBoundingClientRect().top > vh) { el.classList.add('wh'); obs.observe(el); }
      });
    }
  }

  function initPills() {
    var map = {
      'Orologi Bulova Uomo':       '/collections/uomo-orologi-bulova',
      'Orologi Citizen Uomo':      '/collections/uomo-orologi-citizen',
      'Orologi Casio G-Shock':     '/collections/uomo-orologi-casio-g-shock',
      'Orologi Lorenz Swiss Made': '/collections/uomo-orologi-lorenz-swiss-made',
      'Orologi Nautica Sub 100M':  '/collections/uomo-orologi-nautica-water-resistant-100m',
      'Orologi Hugo Boss Uomo':    '/collections/uomo-orologi-hugo-boss',
      'Orologi Scuderia Ferrari':  '/collections/uomo-orologi-scuderia-ferrari',
      'Orologi Cinturino Pelle':   '/collections/orologi-uomo-cinturino-pelle',
      'Orologi Automatici':        '/collections/orologi-automatici',
      'Orologi Cronografo':        '/collections/uomo-orologi-cronografo',
      'Subacquei WR 100M':         '/collections/uomo-orologi-subacqueo-wr-100',
      'Orologi Bulova Donna':      '/collections/donna-orologi-bulova',
      'Orologi Citizen Donna':     '/collections/orologi-citizen-da-donna',
      'Orologi Liu Jo Donna':      '/collections/donna-orologi-liu-jo',
      'Orologi Lorenz Donna':      '/collections/donna-orologio-lorenz',
      'Smartwatch Ops':            '/collections/ops-objects-smartwatch',
      'Orologi Guess Donna':       '/collections/donna-orologi-guess',
      'Orologi Donna Acciaio':     '/collections/donna-orologi-acciaio',
      'Con Diamanti':              '/collections/donna-orologi-diamanti',
      'In Oro 18k':                '/collections/donna-orologi-oro-18k',
      'Cinturino Pelle':           '/collections/donna-orologi-cinturino-pelle'
    };
    document.querySelectorAll('.g3-wpill').forEach(function (pill) {
      var href = map[pill.textContent.trim()];
      if (href) {
        var a = document.createElement('a');
        a.href = href; a.className = pill.className; a.textContent = pill.textContent;
        pill.parentNode.replaceChild(a, pill);
      }
    });
  }

  function run() { fixBg(); initReveal(); initPills(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
})();
